module.exports = __webpack_public_path__ + "static/media/ChatCircleDots.40ecc6ee.svg";